$shm_projects_tasks $mol_book2
	project_id \
	filter? \
	task_add_enabled true
	pages <= task_pages /
	List $shm_service_task_list
		title \Задачи
		add_title \Добавить
		filter? <=> filter?
		add? <=> task_add? null
		add_enabled <= task_add_enabled
		task_rows <= task_rows /
		task_arg* <= task_arg* *
		task_title* <= task_title* \
		task_meta* <= task_meta* \
		task_marker_rows* <= task_marker_rows* /
		task_current* <= task_current* false
		task_open*? <=> task_open*? null
		task_pinned*? <=> task_pinned*? false
		task_archived*? <=> task_archived*? false
		task_is_new* false
		sort_by? <=> sort_by? \changed
		sort_order? <=> sort_order? \desc
	Empty $mol_text
		text \Задач нет
	Task_busy* $mol_view
		attr *
			^
			title \Задача сейчас выполняется
	Task_updated* $mol_view
		attr *
			^
			title \Задача обновлена
		sub / \●
	Task* $shm_projects_task
		project_id <= project_id
		task_id <= task_id* \
